import { Grid, CircularProgress, Theme } from '@mui/material';
import { GVTypography } from 'components/lib';
import { getStyleVariables } from 'styles/vars';
import { makeStyles } from 'tss-react/mui';

export const useDifferenceListSharedStyles = makeStyles()((theme: Theme) => {
  const styleVariables = getStyleVariables(theme);
  return {
    containerPadding: {
      paddingTop: theme.spacing(4),
      paddingLeft: theme.spacing(2),
    },
    differenceContainer: {
      paddingBottom: theme.spacing(0.5),
    },
    scrollBar: styleVariables.scrollBar,
    zeroResults: { display: 'flex', justifyContent: 'center', marginTop: theme.spacing(5) },
  };
});

export const DifferenceListLoading = ({ className }: { className: string }) => (
  <Grid container direction="column" alignItems="center" item className={className}>
    <Grid item mb={2}>
      <CircularProgress size={32} />
    </Grid>
    <Grid item>
      <GVTypography>Applying Results...</GVTypography>
    </Grid>
  </Grid>
);

export const DifferenceListZeroResultsHeader = ({ className }: { className: string }) => (
  <GVTypography className={className} emphasis="medium" fontWeight={400} fontSize="12px">
    You have 0 results.
  </GVTypography>
);
